<template>
  <div class='main-search default-content'>
    <div class="main-search__container">
      <div class='main-search__terms'>
        <a class='main-search__terms-item' :class="termValue === 0 ? 'main-search__terms-item--active' : ''" href='#' @click.prevent='changeTermValue(0)'>{{locales.pages && locales.pages.long_term_rent}}</a>
        <a class='main-search__terms-item' :class="termValue === 1 ? 'main-search__terms-item--active' : ''" href='#' @click.prevent='changeTermValue(1)'>{{locales.pages && locales.pages.short_term_booking}}</a>
      </div>
      <form class='main-search__form'>
        <div class='main-search__input-area'>
          <i class='icon-search'/>
          <div class='main-search__search'>
            <input
              class='main-search__search-input'
              v-model='phrase'
              type='text'
              :placeholder='locales.common && locales.common.start_typing_here'
              autocomplete='off'
              @keyup='suggest'
              @keydown='clearTimeout'
              @blur='blur'
              @focus='showList = true'
              @keydown.enter.prevent
            />
            <ul class='main-search__result-list' v-if='showList && suggestions.length'>
              <li
                v-for='item in suggestions'
                class='main-search__result-list-item'
                :class="{ 'main-search__result-list-item--selected': item === focused }"
                :key='item.id'
                @click='pick(item)'
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class='main-search__select'>
            <select v-model='distance' type='text' class='main-search__select-item' name='ray'>
              <option value='0'>0 km</option>
              <option value='10'>10 km</option>
              <option value='20'>20 km</option>
              <option value='40'>40 km</option>
            </select>
          </div>
        </div>
        <div class='main-search__submit'>
          <button class='theme-btn theme-btn--block theme-btn--primary' type='submit' @click.prevent='search'>
            Search
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import _ from 'lodash';
  import $ from 'jquery';

  export default {
    props: {
      submitUrl: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        phrase: '',
        model: null,
        distance: '20',
        showList: false,
        typingTimer: null,
        doneTypingInterval: 700,
        focused: null,
        suggestions: [],
      };
    },
    computed: {
      ...mapGetters(["locales"]),
      termValue: function() {
        return this.$store.state.term.termValue;
      },
    },
    methods: {
      changeTermValue(value) {
        this.$store.commit('CHANGE_TERM_VALUE', value);
      },
      suggest(event) {
        let keyCode = event.keyCode;

        switch (keyCode) {
          case 38:
            if (_.indexOf(this.suggestions, this.focused) === 0) {
              this.focused = this.suggestions[this.suggestions.length - 1];
            } else {
              this.focused = this.suggestions[
              _.indexOf(this.suggestions, this.focused) - 1
                ];
            }
            break;
          case 40:
            if (_.indexOf(this.suggestions, this.focused) === this.suggestions.length - 1
            ) {
              this.focused = this.suggestions[0];
            } else {
              this.focused = this.suggestions[
              _.indexOf(this.suggestions, this.focused) + 1
                ];
            }

            break;
          case 13:
            this.pick(this.focused);
            break;
          case 9:
            break;
          default:
            this.typing();
            break;
        }
      },
      pick(item) {
        if (item) {
          this.phrase = item.name;
          this.model = item.id;
        } else {
          this.phrase = '';
          this.model = null;
        }
        this.showList = false;
        this.focused = null;
      },
      typing() {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.doneTyping, this.doneTypingInterval);
        this.showList = true;
        this.model = this.phrase;
      },
      clearTimeout() {
        clearTimeout(this.typingTimer);
      },
      doneTyping() {
        $.get('/admin/autocomplete/locations' + '?q=' + this.phrase).then((response) => {
          this.suggestions = response;
        });
      },
      blur() {
        setTimeout(() => {
          this.showList = false;
        }, 300);
      },
      search() {
        const searchParams = new URLSearchParams({
          location: this.model,
          '_labels[location]': this.phrase,
          ray: this.distance,
        }).toString();
        window.location.href = `${this.submitUrl}?${searchParams}`;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/MainSearch.vue